import { GButton, GTooltip } from 'components/basic-blocks'
import { useStores } from 'hooks'
import { useMemo, useState } from 'react'
import { content } from '../constants'
import { RunReportsDialog, ScheduleReportsDialog } from '../triggers/runReports'
import { OnDemandReportViewProps } from '../types'

export const ReportView = (props: OnDemandReportViewProps) => {
	const [open, setOpen] = useState(false)
	const [openSchedule, setOpenSchedule] = useState(false)
	const { type } = props
	const { accountStore, assetStore } = useStores()
	const { demoMode } = assetStore
	const plan = accountStore?.account?.billing?.subscription?.plan?.tier || ''
	const isPro = useMemo(
		() => demoMode || plan === 'pro' || plan === 'custom_pro',
		[demoMode, plan]
	)

	return (
		<div className="flex flex-row [&:not(:last-child)]:border-b pb-4 items-center">
			<div className="flex flex-col gap-1 w-full">
				<div className="text-t-coupon text-base font-medium">
					{content[type].title}
				</div>
				<div className="text-base text-t-desc-gray">{content[type].subTitle}</div>
			</div>
			<div>
				<GTooltip
					content={
						demoMode ? 'This action is disabled when demo data is displayed' : ''
					}
				>
					<div className="flex items-center gap-3">
						<GButton
							label="Schedule"
							onClick={() => setOpenSchedule(!openSchedule)}
							color="buttonPrimary"
							variant="text"
							size="xs"
							className="min-w-[45px] rounded-full shadow-none text-t-desc-gray hover:bg-transparent border-t-google-btn"
							disabled={demoMode}
							labelClassName="text-sm font-medium"
						/>
						<GTooltip
							content={
								!isPro ? 'Available on Pro plan — upgrade to unlock.' : ''
							}
						>
							<GButton
								label="Generate"
								onClick={() => setOpen(!open)}
								color="primary"
								variant="contained"
								size="xs"
								shape="circle"
								disabled={!isPro || demoMode}
								labelClassName="text-sm font-medium"
							/>
						</GTooltip>
					</div>
				</GTooltip>
				<RunReportsDialog
					open={open}
					onClose={() => setOpen(false)}
					type={type}
				/>
				<ScheduleReportsDialog
					type={type}
					open={openSchedule}
					onClose={() => setOpenSchedule(false)}
				/>
			</div>
		</div>
	)
}
